import { createContext } from 'react';
import { modelInterface, annotSpecies } from './types';
import { EnvForm } from "./Forms/FormEnv/env_types";
import { CompartForm } from "./Forms/FormComparts/compart_types";
import initialState from './Forms/formInitialState'

const modelContext = createContext<modelInterface>({
	modelJson: {
		"cell4d:environmentVariables": initialState["cell4d:environmentVariables"],
		"listOfCompartments": initialState["listOfCompartments"],
		annotSpecies: null,
		listOfSpecies: null,
		listOfReactions: null,
		listOfEvents: null,
	},
	setModelJson: () => {},
	appendModelJson: (key: string, new_state: any) => {},

	modelStatus: [],
	setModelStatus: () => {},
	validateModel: () => {},

	compartList: [], 
	updateComparts: () => {}, 

	annotSpeciesList: {}, 
	updateAnnot: () => {}, 

	speciesList: [], 
	updateSpecies: () => {}, 

	metabList: [], 

	writeAnnotList: () => {},

});

export default modelContext;
